<span [ngStyle]="{'display': authService.isLoggedIn() ? 'inline' : 'none' }">
  <button [routerLink]="['/user-settings']" class="settings-box" mat-button>
    <i class="material-icons">settings</i>
    {{ authService.loggedUser() }}
  </button>
</span>